import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useExistingPermissionAccessRequestQuery } from '../../../../hooks/useExistingPermissionAccessRequestQuery';
import { formatAccessRequestDate } from '../../../../utils/formatAccessRequestDate';
import { RequestAccessTrigger } from '../../../internal/RequestAccess/RequestAccessTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ActionableItemDisplay({
  requestAccessConfig,
  taskDescription,
  title,
  children,
  tooltipProps
}) {
  var _requestAccessConfig$;
  const appLocationId = requestAccessConfig === null || requestAccessConfig === void 0 || (_requestAccessConfig$ = requestAccessConfig.appLocation) === null || _requestAccessConfig$ === void 0 ? void 0 : _requestAccessConfig$.id;
  const {
    existingPermissionAccessRequest,
    isExistingPermissionAccessRequestLoading,
    refetchExistingPermissionAccessRequest
  } = useExistingPermissionAccessRequestQuery({
    appLocationId
  });
  const hasExistingRequest = !!existingPermissionAccessRequest;
  const formattedCreatedAt = hasExistingRequest ? formatAccessRequestDate(existingPermissionAccessRequest.createdAt) : '';
  const resolvedTooltipProps = Object.assign({}, tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.domProps, tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.tokenProps, {
    placement: tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.placement
  });
  function renderTooltip(onRequestAccess) {
    var _requestAccessConfig$2, _requestAccessConfig$3;
    const requestAccessContent = isExistingPermissionAccessRequestLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "xs"
    }) : hasExistingRequest ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "access-check-lib.accessCheck.messaging.fullPage.existingRequest.tooltip",
      options: {
        appLocationLabel: (_requestAccessConfig$2 = requestAccessConfig === null || requestAccessConfig === void 0 || (_requestAccessConfig$3 = requestAccessConfig.appLocation) === null || _requestAccessConfig$3 === void 0 ? void 0 : _requestAccessConfig$3.label) !== null && _requestAccessConfig$2 !== void 0 ? _requestAccessConfig$2 : '',
        createdAt: formattedCreatedAt
      }
    }) : onRequestAccess ? /*#__PURE__*/_jsx(Link, {
      onClick: onRequestAccess,
      "data-test-id": "request-access-cta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "access-check-lib.accessCheck.messaging.requestAccess.action"
      })
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "access-check-lib.accessCheck.messaging.adminResolveAction"
    });
    const fullTooltipTitle = /*#__PURE__*/_jsxs(TFlex, {
      flexDirection: "column",
      gap: 8,
      children: [title, requestAccessContent]
    });
    return /*#__PURE__*/_jsx(Tooltip, Object.assign({
      title: fullTooltipTitle,
      maxInlineSize: "330px"
    }, resolvedTooltipProps, {
      children: children
    }));
  }
  if (!appLocationId || hasExistingRequest) {
    return renderTooltip();
  }
  return /*#__PURE__*/_jsx(RequestAccessTrigger, {
    requestAccessConfig: requestAccessConfig,
    taskDescription: taskDescription,
    onRequestAccessSuccess: refetchExistingPermissionAccessRequest,
    children: openModal => renderTooltip(openModal)
  });
}